/**
 * Ячейка «Логотип» (28.09.2026): превью как в приложении (скруглённый квадрат),
 * загрузить новый, убрать. Сервер сам обрежет картинку в квадрат 256 px и
 * пересоберёт список для приложения: у жителей логотип появится в течение часа,
 * без обновления приложения.
 */
import React, { useState } from 'react';
import { Button, Popconfirm, Space, Tooltip, Upload, message } from 'antd';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';

interface Props {
  url?: string | null;
  /** Подпись для пустого превью: первая буква названия, как в приложении. */
  name: string;
  onUpload: (file: File) => Promise<unknown>;
  onRemove: () => Promise<unknown>;
  uploadLabel?: string;
  removeConfirm?: string;
}

const SIZE = 40;

const LogoCell: React.FC<Props> = ({ url, name, onUpload, onRemove, uploadLabel, removeConfirm }) => {
  const [busy, setBusy] = useState(false);

  const run = async (fn: () => Promise<unknown>, ok: string) => {
    setBusy(true);
    try {
      await fn();
      message.success(ok);
    } catch (e: unknown) {
      const detail = (e as { response?: { data?: { detail?: string } } })?.response?.data?.detail;
      message.error(detail || 'Не получилось');
    } finally {
      setBusy(false);
    }
  };

  const letter = (name.replace(/^[^\p{L}\p{N}]+/u, '').charAt(0) || '·').toUpperCase();

  return (
    <Space size={8}>
      {url ? (
        <img
          src={url}
          alt=""
          style={{ width: SIZE, height: SIZE, borderRadius: 11, border: '1px solid #E3E8F0', objectFit: 'cover', background: '#fff' }}
        />
      ) : (
        <div
          style={{
            width: SIZE, height: SIZE, borderRadius: 11, background: '#0B1A33', color: '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700,
          }}
        >
          {letter}
        </div>
      )}
      <Upload
        accept="image/png,image/jpeg,image/webp"
        showUploadList={false}
        beforeUpload={(file) => {
          void run(() => onUpload(file as File), 'Логотип загружен');
          return false;
        }}
      >
        <Tooltip title={uploadLabel || 'Загрузить логотип'}>
          <Button size="small" icon={<UploadOutlined />} loading={busy} />
        </Tooltip>
      </Upload>
      {url ? (
        <Popconfirm title={removeConfirm || 'Убрать логотип?'} onConfirm={() => run(onRemove, 'Логотип убран')}>
          <Button size="small" danger icon={<DeleteOutlined />} disabled={busy} />
        </Popconfirm>
      ) : null}
    </Space>
  );
};

export default LogoCell;
